/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_DescriptionInputs */

const en_admin_funnel_description = /** @type {(inputs: Admin_Funnel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unique-visitor conversion from the site's own event table. Days are cut at UTC+8.`)
};

/**
* | output |
* | --- |
* | "Unique-visitor conversion from the site's own event table. Days are cut at UTC+8." |
*
* @param {Admin_Funnel_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_description = /** @type {((inputs?: Admin_Funnel_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_description(inputs)
});
export { admin_funnel_description as "admin.funnel.description" }